import ArrowDown from '@clearkit/icons/glyphs/ArrowDown';
import ArrowUp from '@clearkit/icons/glyphs/ArrowUp';
import InfoHollow from '@clearkit/icons/glyphs/InfoHollow';
// eslint-disable-next-line clearbit-x/no-tree-shaking-imports
import { fade } from '@material-ui/core/styles/colorManipulator';
import { CKTooltip } from 'clearkit';
import { Tabbable } from 'reakit/Tabbable';

const deltaDisplay = (delta) => {
  switch (true) {
    case isNaN(delta):
      return '0%';
    case !isFinite(delta):
      return null;
    default:
      return Math.abs((delta * 100).toFixed()) + '%';
  }
};

const iconDisplay = (delta) => {
  switch (true) {
    case isNaN(delta):
      return '⇌';
    case !isFinite(delta):
    case delta > 0:
      return <ArrowUp width={12} />;
    case delta < 0:
      return <ArrowDown width={12} />;
    default:
      return null;
  }
};

const InnerContent = ({ data, accent }) => {
  const { currentInfluencedValue, previousInfluencedValue } = data;
  const delta =
    (currentInfluencedValue - previousInfluencedValue) /
    previousInfluencedValue;

  return (
    <div
      className={classnames({
        'text-indigo': accent.variable === 'indigo',
        'text-aqua': accent.variable === 'aqua',
        'text-green': accent.variable === 'green',
        'text-yellow': accent.variable === 'yellow',
        'text-purple': accent.variable === 'purple',
      })}>
      <p className="font-bold tracking-tight" style={{ fontSize: 24 }}>
        {currentInfluencedValue.toLocaleString()}
      </p>
      <div
        className="flex items-center justify-center font-medium"
        style={{ fontSize: 11 }}>
        <span>{iconDisplay(delta)}</span>
        <span>{deltaDisplay(delta)}</span>
      </div>
    </div>
  );
};

export const StageListItem = ({
  accent,
  active,
  data,
  label,
  onClick,
  progress,
  tooltip,
}) => {
  return (
    <button
      className={classnames(
        'flex flex-col items-center flex-1 p-2 text-center bg-gray-0 focus:outline-none focus:ring-2 ring-offset-1 rounded',
        {
          'ring-indigo-100': accent.variable === 'indigo',
          'ring-aqua-100': accent.variable === 'aqua',
          'ring-green-100': accent.variable === 'green',
          'ring-yellow-100': accent.variable === 'yellow',
          'ring-purple-100': accent.variable === 'purple',
          'ring-offset-indigo-500': accent.variable === 'indigo',
          'ring-offset-aqua-500': accent.variable === 'aqua',
          'ring-offset-green-500': accent.variable === 'green',
          'ring-offset-yellow-500': accent.variable === 'yellow',
          'ring-offset-purple-500': accent.variable === 'purple',
        },
      )}
      style={{
        backgroundColor: active ? fade(accent.hex, 0.2) : null,
      }}
      onClick={onClick}>
      <div className="flex items-center justify-center flex-1">
        <InnerContent
          active={active}
          data={data}
          accent={accent}
          progress={progress}
          label={label}
        />
      </div>
      <div className="inline-flex items-center justify-center gap-1">
        <div
          className={classnames('w-2 h-2 rounded', {
            'bg-indigo': accent.variable === 'indigo',
            'bg-aqua': accent.variable === 'aqua',
            'bg-green': accent.variable === 'green',
            'bg-yellow': accent.variable === 'yellow',
            'bg-purple': accent.variable === 'purple',
          })}
        />
        <p className="text-xs font-medium text-gray whitespace-nowrap">
          {label}
        </p>
        {Boolean(tooltip) && (
          <CKTooltip tooltip={tooltip} placement="bottom">
            <Tabbable className="relative">
              <InfoHollow className="text-gray" width={14} />
            </Tabbable>
          </CKTooltip>
        )}
      </div>
    </button>
  );
};
